import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';

export function useFacebookShareMetadata(): Readonly<Record<string, string>> | undefined {
	const {
		data: {
			facebookHeadlineExperiment: { variation, name },
		},
	} = usePsfPromoteOrSharePageData();

	return useMemo(() => {
		if (!name) {
			return undefined;
		}
		if (variation.endsWith('control')) {
			return undefined;
		}

		return {
			utm_content: `fbogexp:${name}:${variation}`,
		};
	}, [name, variation]);
}
